//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import throttle from 'lodash/throttle';
// import LoaderSpin from '@/components/modules/common/LoaderSpin.vue';
import { faCircleNotch } from '@fortawesome/pro-solid-svg-icons';

import { faMeSearch } from '@motionelements/assets/src/js/me-font/icons/me-font-icons-solid.js';

export default {
  name: 'button-ladda-function',
  // components: {
  //   LoaderSpin,
  // },
  props: {
    buttonClass: {
      type: String,
      default: 'btn btn-light',
    },
    buttonDisabled: {
      type: Boolean,
      default: false,
    },
    buttonLoading: {
      type: Boolean,
      default: false,
    },
    click: {
      required: false,
      type: [Function, Promise],
    },
    title: {
      type: String,
    },
    icon: {
      type: [Array, Object],
      default() {
        return faMeSearch;
      },
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    showText: {
      type: Boolean,
      default: true,
    },
    throttleInterval: {
      type: Number,
      default: 1000,
    },
  },
  data() {
    return {
      faCircleNotch,
      selfLoading: false,
    };
  },
  methods: {
    // button ladda throttle
    clickEvent() {
      const component = this;
      throttle(function () {
        this.handleClick();
      }, this.throttleInterval).call(component);
    },
    async handleClick() {
      // console.log('handleClick', typeof this.click);
      this.selfLoading = true;
      // use try catch to detect if props click is or not promise
      try {
        await this.click().then((data) => {
          if (data) {
            console.log('function success, has data');
            this.$emit('handle-click', data);
          }
        }).catch((error) => {
          console.error('function return error: ', error);
          this.$emit('handle-click', error);
        });
      } catch (error) {
        console.log('no then, function executed');
        this.$emit('handle-click', 'clicked');
      } finally {
        this.selfLoading = false;
      }
    },
  },
};
